import React from "react";
import "./HomeBanner.css";
const HomeBanner = () => {
  return (
    <section className="home-banner">
      <video
        className="banner-video"
        src="/assets/video/bannervideo.mp4"
        autoPlay
        loop
        muted
        playsInline
      />

      <div className="banner-overlay"></div>

      <div className="banner-content container">
        <div className="logo-wrapper">
          <img
            src="/assets/images/newhome/homelogo.png"
            alt="Falcon Logo"
            className="banner-logo"
          />
        </div>
        <div>
          <h1 className="heading red-heading">
            {" "}
            Professional stage FX solutions
          </h1>
          <h1 className="heading">for Concerts wedding & corporate events</h1>
        </div>
      </div>
    </section>
  );
};

export default HomeBanner;
